import React from 'react';
import PortfolioUniversePage from './PortfolioUniversePage';

export default function PrincipalProtectionPage() {
  return (
    <PortfolioUniversePage
      strategyId="principal-protection"
      portfolioHoldingType="PRINCIPAL_PROTECTION"
    />
  );
}
